// For demo purposes we are adding all locales, you SHOULD NOT DO THIS IN PRODUCTION
import { configure } from "vee-validate";
import { localize } from "@vee-validate/i18n";
import _ from "lodash";
import { en } from "@/lang/en";
import { ca } from "@/lang/ca";
import { es } from "@/lang/es";
import { he } from "@/lang/he";
import { ja } from "@/lang/ja";
import { pt } from "@/lang/pt";
import { fr } from "@/lang/fr";

const codes = [
  // "ar",
  // "et",
  "ja",
  // "nn_NO",
  // "sr_Latin",
  // "az",
  // "eu",
  // "ka",
  // "pl",
  // "sv",
  // "bg",
  // "fa",
  // "ko",
  // "pt_BR",
  // "th",
  "ca",
  // "fi",
  // "lt",
  "pt_PT",
  // "tr",
  // "cs",
  "fr",
  // "lv",
  // "ro",
  // "uk",
  // "da",
  "he",
  // "mn",
  // "ru",
  // "vi",
  // "de",
  // "hr",
  // "ms_MY",
  // "sk",
  // "zh_CN",
  // "el",
  // "hu",
  // "nb_NO",
  // "sl",
  // "zh_TW",
  "en",
  // "id",
  // "ne",
  // "sq",
  "es"
  // "it",
  // "nl",
  // "sr"
];

export const getMatchedLocale = (appLocale: string) =>
  appLocale === "pt" ? "pt_PT" : appLocale;

export const customDictionary = {
  [getMatchedLocale("en")]: en.validation,
  [getMatchedLocale("ca")]: ca.validation,
  [getMatchedLocale("es")]: es.validation,
  [getMatchedLocale("he")]: he.validation,
  [getMatchedLocale("pt")]: pt.validation,
  [getMatchedLocale("ja")]: ja.validation,
  [getMatchedLocale("fr")]: fr.validation
};

export const setValidationMessages = async () => {
  const locales = await Promise.all(
    codes.map(code => import(`@vee-validate/i18n/dist/locale/${code}.json`))
  );

  const dictionary = locales.reduce((dict, curr, idx) => {
    const code = codes[idx];
    dict[code] = curr;

    return dict;
  }, {});

  _.forEach(_.keys(customDictionary), k => {
    _.set(
      dictionary,
      `${k}.messages`,
      _.assign(
        dictionary[k].messages,
        customDictionary[k as "en" | "ca" | "es" | "he" | "pt_PT" | "ja" | "fr"]
      )
    );
  });

  configure({
    generateMessage: localize(dictionary)
  });
};
